import React from 'react';
import PropTypes from 'prop-types';
import './index.css';

CommentsHeader.propTypes = {
    amountComments: PropTypes.number.isRequired,
};

CommentsHeader.defaultProps = {
    amountComments: 0,
}

function CommentsHeader(props) {
    return (
        <div className='comments-header'>
            <h4>{props.amountComments} Comments</h4>
        </div>
    );
}

export default CommentsHeader;